import api from './api';

const authService = {
  login: async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    return res.data;
  },
  register: async (data) => {
    const res = await api.post('/auth/register', {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      mobile: data.mobile || undefined,
      password: data.password,
      password_confirmation: data.confirmPassword,
      accept_terms: !!data.termsAccepted
    });
    return res.data;
  },
  verifyEmail: async (token) => {
    const res = await api.post('/auth/verify-email', { token });
    return res.data;
  },
  verifyMobile: async (code) => {
    const res = await api.post('/auth/verify-mobile', { code });
    return res.data;
  },
  setupMfa: async () => {
    const res = await api.post('/auth/mfa/setup');
    return res.data;
  },
  // `secret` is only sent while enrolling an authenticator app (from the setup step); afterwards the
  // server uses the stored secret. `channel` is 'app' (default) or 'email' — see requestMfaEmailCode.
  verifyMfa: async (code, { secret, channel } = {}) => {
    const res = await api.post('/auth/mfa/verify', { code, secret, channel });
    return res.data;
  },
  // Emails a fresh one-time code — call this right before verifyMfa(code, { channel: 'email' }),
  // both to enrol in the email method and for every later sign-in that uses it.
  requestMfaEmailCode: async () => (await api.post('/auth/mfa/email/request')).data,
  disableMfa: async (password) => (await api.post('/auth/mfa/disable', { password })).data,
  changePassword: async ({ currentPassword, password, passwordConfirmation }) =>
    (await api.put('/users/me/password', {
      current_password: currentPassword,
      password,
      password_confirmation: passwordConfirmation,
    })).data,
  refreshToken: async (refreshToken) => {
    const res = await api.post('/auth/refresh', null, {
      headers: { Authorization: `Bearer ${refreshToken}` }
    });
    return res.data;
  },
  logout: async () => {
    const res = await api.post('/auth/logout');
    return res.data;
  },
  forgotPassword: async (email) => (await api.post('/auth/forgot-password', { email })).data,
  resetPassword: async (data) => (await api.post('/auth/reset-password', data)).data,
  getProfile: async () => {
    const res = await api.get('/users/me');
    return res.data;
  },
  updateProfile: async (data) => {
    const res = await api.put('/users/me', data);
    return res.data;
  }
};

export default authService;
